module.exports = new __parcel__URL__("apply_c_faq_closed_btn_ko.135e8141.webp").toString();